import PropTypes from 'prop-types'
import Notification from "./Notification"
import Toast from "./Toast"
import { NOTIFICATION } from '@/constants'

const props = {
  notificationList: PropTypes.array,
  type: PropTypes.oneOf([NOTIFICATION.NOTIFICATION, NOTIFICATION.TOAST])
}

export default function NotificationContainer({notificationList,type=Notification.NOTIFICATION}){
  // TODO: Implement Notification Component and COntainer
  return (
    <div
      className={
        ` tw-fixed  tw-z-40 tw-self-center tw-flex tw-flex-col tw-items-center tw-gap-2
        ${type === NOTIFICATION.TOAST ? "tw-bottom-20" : "tw-top-20"}
        `
      }
    >
    {
      notificationList.map(notification => {
        let notificationProps = {
          icon: notification.icon,
          title: notification.title,
          message: notification.message
        }
        switch (type) {
          case NOTIFICATION.TOAST:
            return <Toast key={notification.id} {...notificationProps}/>
          default:
            return <Notification key={notification.id} {...notificationProps}/>
        }
      }
      )
    }
    </div>
  )
}

NotificationContainer.propTypes = props
